import { z } from 'zod'

// ─── Grid Row (real-time data from a /data endpoint) ───
//
// One row of live market data as returned by the scanner-family /data
// endpoints. A passthrough schema: the required keys are always present, and
// any additional column selected by the panel rides along untyped. Shared by
// the watchlist grid and the theme-tracker member grid.

export const GridRowSchema = z
  .object({
    watchlist_id: z.number(),
    item_id: z.number(),
    row_order: z.number(),
    ticker: z.string(),
    halt: z.union([z.boolean(), z.number()]).nullable().optional(),
    ssr: z.union([z.boolean(), z.number()]).nullable().optional(),
  })
  .passthrough()

export type GridRow = z.infer<typeof GridRowSchema>
